import api from '@pray/shared/utils/api';

import type { SmsLogsResponse } from './types';

type GetSmsLogsProps = {
  artistId: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  perPage?: number;
};

export async function getSmsLogs({ artistId, startDate, endDate, page, perPage }: GetSmsLogsProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config/logs`;

  const params: Record<string, string> = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  if (page) params.page = String(page);
  if (perPage) params.per_page = String(perPage);

  const response = await api.executeGetRequest<{ data: SmsLogsResponse }>(url, params);

  return response.data;
}
